import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Header from './components/Header'
import Footer from './components/Footer'
import CookieBanner from './components/CookieBanner'
import PrivacyPage from './pages/PrivacyPage'
import TermsPage from './pages/TermsPage'
import HomePage from './pages/HomePage'
import ArticlePage from './pages/ArticlePage'
import AboutPage from './pages/AboutPage'
import AuthorPage from './pages/AuthorPage'
import CategoryPage from './pages/CategoryPage'
import './App.css'

function App() {
  return (
    <Router>
      <div className="app">
        <a href="#main" className="skip-link">Skip to content</a>
        <Header />
        <main id="main" className="main-content">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/article/:slug" element={<ArticlePage />} />
            <Route path="/category/:slug" element={<CategoryPage />} />
            <Route path="/about" element={<AboutPage />} />
              <Route path="/author" element={<AuthorPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/terms" element={<TermsPage />} />
          </Routes>
        </main>
        <Footer />
        <CookieBanner />
      </div>
    </Router>
  )
}

export default App
